import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthenticationService } from '../../../../services/authentication.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-dialog-login',
  templateUrl: './dialog-login.component.html',
  styleUrls: ['./dialog-login.component.css']
})
export class DialogLogin implements OnInit {
  username: string;
  password: string;
  formGroup: FormGroup;
  error: boolean;
  errMsg: string;
  loading: boolean;

  

  constructor(public dialogRef: MatDialogRef<DialogLogin>,
    @Inject(AuthenticationService) private authService: AuthenticationService) 
  {}

  ngOnInit() {
    this.authService.navigateAwaySelection$.next(false);
    this.error = false;
    this.loading = false;
    this.formGroup = new FormGroup({
      username: new FormControl('', [
        Validators.required
      ]),
      password: new FormControl('', [
        Validators.required
      ])
    });
  }

  login() {
    this.error = false;
    this.loading = true;
    if (this.formGroup.valid) {
      this.authService.login(this.username, this.password)
        .subscribe(result => {
          if (result.error === false) {
            this.dialogRef.close(true);
            this.authService.navigateAwaySelection$.next(true);
          } else {
            this.error = true;
            this.authService.navigateAwaySelection$.next(false);
            this.errMsg = result.msg;
          }
          this.loading = false;
        },
        error => {
          this.loading = false;
          this.authService.navigateAwaySelection$.next(false);
          this.error = true;
          if (error.status === 401) {
            this.errMsg = 'Utente non autorizzato!';
          } else if (error.status === 0) {
            this.errMsg = 'Servizio non disponibile!';
          } else {
            this.errMsg = 'Errore!';
          }
        });
    }
  }
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/components/utilita/dialogs/dialog-login/dialog-login.component.ts